import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components/macro';
import { theme, ifProp } from 'styled-tools';
import { Field } from 'react-final-form';
import DatePicker from 'react-datepicker';
import { format, isValid, parseISO } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { ErrorMessage, FieldLabel } from '../index';

export const DateIcon = styled(FontAwesomeIcon).attrs({
  icon: faCalendarAlt,
})``;

export const StyledDatePicker = styled(DatePicker)`
  border: 0.0625rem solid ${theme('colors.mediumGray')};
  padding-left: 2.5rem;
  height: calc(1.5em + 0.75rem + 2px);
  width: 100%;
  border-radius: 0.25rem;

  .react-datepicker-wrapper {
    width: 100%;
  }

  ${ifProp(
    'invalid',
    css`
      border-color: ${theme('colors.red')};
    `
  )}
`;

export const DatePickerWrapper = styled.div`
  position: relative;
  margin-bottom: 1rem;
  /**
  * It wasn't possible to override these classes without !important.
   */
  .text-primary {
    color: ${theme('colors.primary')} !important;
  }

  .bg-primary {
    color: ${theme('colors.white')};
    background: ${theme('colors.primary')} !important;
  }

  ${DateIcon} {
    position: absolute;
    left: 1rem;
    top: 0.65rem;
    z-index: 999;
  }
`;

const propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  minDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  maxDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  disabled: PropTypes.bool,
};

function DatePickerInput({ name, label, minDate, maxDate, disabled = false }) {
  return (
    <Field name={name}>
      {({ input, meta }) => (
        <div>
          {label && <FieldLabel htmlFor={name}>{label}</FieldLabel>}
          <DatePickerWrapper>
            <DateIcon />
            <StyledDatePicker
              id={name}
              invalid={meta.error && meta.touched}
              minDate={minDate}
              maxDate={maxDate}
              placeholderText='MM/DD/YYYY'
              dateFormat='MM/dd/yyyy'
              showPopperArrow={false}
              selected={input.value && isValid(parseISO(input.value)) ? parseISO(input.value) : null}
              onChange={date => {
                const value = date && isValid(date) ? format(date, 'yyyy-MM-dd') : '';
                input.onChange(value);
              }}
              disabled={disabled}
            />
            {meta.touched && meta.error && <ErrorMessage>{meta.error}</ErrorMessage>}
          </DatePickerWrapper>
        </div>
      )}
    </Field>
  );
}

DatePickerInput.propTypes = propTypes;

export default DatePickerInput;
